const SIZES = {
  MEDIUM: "medium",
};

export { SIZES };
